<template>
	<div class="exposition-left-main">
		<div class="exposition-left-main-cell">
			<dianganggaikuang></dianganggaikuang>
		</div>
		<div class="exposition-left-main-cell">
			<chunengxinxi></chunengxinxi>
		</div>
		<div class="exposition-left-main-cell">
			<guangfuxinxi></guangfuxinxi>
		</div>
		<div class="exposition-left-main-cell">
			<chongfangliangqushi></chongfangliangqushi>
		</div>
		<div class="exposition-left-main-cell">
			<fadiangonglv></fadiangonglv>
		</div>
		<div class="exposition-left-main-cell">
			<tanpaijianqushi></tanpaijianqushi>
		</div>
		<div class="exposition-left-main-cell">
			<fadianqushi></fadianqushi>
		</div>
		<div class="exposition-left-main-cell">
			<tanpaijianqushitu></tanpaijianqushitu>
		</div>
	</div>
</template>

<script>
	import dianganggaikuang from '@/views/components/exposition/dianganggaikuang.vue'
	import chunengxinxi from '@/views/components/exposition/chunengxinxi.vue'
	import guangfuxinxi from '@/views/components/exposition/guangfuxinxi.vue'
	import chongfangliangqushi from '@/views/components/exposition/chongfangliangqushi.vue'
	import fadiangonglv from '@/views/components/exposition/fadiangonglv.vue'
	import tanpaijianqushi from '@/views/components/exposition/tanpaijianqushi.vue'
	import fadianqushi from '@/views/components/exposition/fadianqushi.vue'
	import tanpaijianqushitu from '@/views/components/exposition/tanpaijianqushitu.vue'
	export default{
		components: {
			tanpaijianqushitu,
			fadianqushi,
			dianganggaikuang,
			chunengxinxi,
			guangfuxinxi,
			chongfangliangqushi,
			fadiangonglv,
			tanpaijianqushi
		}
	}
</script>

<style lang="scss" scope>
	.exposition-left-main {
		width: 930px;
		display: flex;
		margin-top: 70px;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-left: 10px;
		.exposition-left-main-cell{
			width: 440px;
			height: 348px;
			margin-left: 20px;
			margin-bottom: 20px;
		}
	}
</style>